import { useState } from "react";
import Slider from "react-slick";
import { Helmet } from 'react-helmet-async';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Seite.css";


// Интерфейс для видео
interface Video {
  src: string;
  name: string;
  description: string;
  thumbnail: string;
  uploadDate: string;
  duration: string;
}

// Компонент для блока с видео или изображениями
const MediaBlock = ({
  src,
  width,
  height,
  isImage,
  isActive = true,
  poster, // Новый проп для poster
}: {
  src: string;
  width: number;
  height: number;
  isImage?: boolean;
  isActive?: boolean;
  poster?: string; // Добавляем poster как опциональный проп
}) => {
  return (
    <div className="media-container">
      {isImage ? (
        <img
          alt="Картина Михаила Врубеля «Демон поверженный»"
          src={src}
          title="Михаил Врубель. Демон поверженный"
          className={`media-content ${src.includes('img7') ? 'img7-specific' : ''}`}
        />
      ) : (
        isActive && (
          <video
            controls
            width={width}
            height={height}
            className="media-content"
            preload="metadata"
            poster={poster} // Добавляем атрибут poster
          >
            <source src={src} type="video/mp4" />
            Ваш браузер не поддерживает воспроизведение видео.
          </video>
        )
      )}
    </div>
  );
};

// Компоненты для стрелок
const PrevArrow = ({
  className,
  style,
  onClick,
}: {
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}) => (
  <button type="button" className={className} style={style} onClick={onClick}>
    ❮
  </button>
);

const NextArrow = ({
  className,
  style,
  onClick,
}: {
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}) => (
  <button type="button" className={className} style={style} onClick={onClick}>
    ❯
  </button>
);

// Компонент для слайдера
const VideoCarousel = ({ videos }: { videos: Video[] }) => {
  const [loadedVideos, setLoadedVideos] = useState<number[]>([0]);

  const settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    beforeChange: (_: number, newIndex: number) => {
      console.log("Switching to slide:", newIndex);
      if (!loadedVideos.includes(newIndex)) {
        setLoadedVideos((prev) => [...prev, newIndex]);
      }
    },
  };

  return (
    <Slider {...settings} className="carousel">
      {videos.map((video, index) => (
        <div key={index}>
          <MediaBlock
            src={`/video/${video.src}`}
            width={590}
            height={448}
            isActive={loadedVideos.includes(index)}
            poster={`https://sergey-mavrodi.com${video.thumbnail}`} // Передаём poster
          />
        </div>
      ))}
    </Slider>
  );
};

// Компонент предупреждения
const WarningMessage = () => (
  <div className="main_fon">
    <div className="main_fon_text">
      <div style={{ margin: "0 auto", textAlign: "center" }}>
        <p>
          <span style={{ fontSize: "150%" }}>ПРЕДУПРЕЖДЕНИЕ!</span>
        </p>
        <p>
          <span style={{ fontWeight: "bold", color: "red", fontSize: "117%" }}>
            В настоящее время МММ <br />не работает в России, Казахстане и Беларуси.
            <br />
            Все сайты в этих странах, выдающие себя за МММ - мошенники!
          </span>
        </p>
        <p>
          <span>В общем, будьте внимательны. Повторяю: это мошенники!</span>
        </p>
        <p>
          <span>Сергей Мавроди</span>
        </p>
        <br />
        <p>
          <span>
            P.S. Напоминаю также в очередной раз, что ни в каких соц.сетях,
            <br />
            твиттерах и пр. меня тоже нет. Всё это обычные прохвосты.
            <br />
            (Чего-то, кстати, расплодившиеся последнее время. :-))
          </span>
        </p>
        <p>
          <span>
            P.P.S. Ни к МММ, ни ко мне лично никакого отношения не имеют.
            <br />
            Обычное жульё. Не попадитесь!
          </span>
        </p>
        <p>
          <span>P.P.P.S. И никаких криптовалют, кстати, я не выпускал.</span>
        </p>
      </div>
    </div>
  </div>
);

// Основной компонент
const Seite = () => {
  const videos: Video[] = [
    {
      src: "official-website-1.mp4",
      name: "Официальный сайт МММ - Видео 1",
      description: "Первое видео с официального сайта Сергея Мавроди.",
      thumbnail: "/video/official-website-1-thumb.webp",
      uploadDate: "2023-01-01T00:00:00+03:00",
      duration: "PT2M30S",
    },
    {
      src: "official-website-2.mp4",
      name: "Официальный сайт МММ - Видео 2",
      description: "Второе видео с официального сайта Сергея Мавроди.",
      thumbnail: "/video/official-website-2-thumb.webp",
      uploadDate: "2023-01-02T00:00:00+03:00",
      duration: "PT2M45S",
    },
    {
      src: "official-website-3.mp4",
      name: "Официальный сайт МММ - Видео 3",
      description: "Третье видео с официального сайта Сергея Мавроди.",
      thumbnail: "/video/official-website-3-thumb.webp",
      uploadDate: "2023-01-03T00:00:00+03:00",
      duration: "PT3M00S",
    },
    {
      src: "mavrodi-warning.mp4",
      name: "Предупреждение от Сергея Мавроди",
      description: "Видео с предупреждением о мошенниках, выдающих себя за МММ.",
      thumbnail: "/video/mavrodi-warning-thumb.webp",
      uploadDate: "2023-01-01T00:00:00+03:00",
      duration: "PT2M30S",
    },
  ];

  // Фильтруем видео для карусели (исключаем mavrodi-warning.mp4)
  const carouselVideos = videos.filter((video) => video.src !== "mavrodi-warning.mp4");

  return (
    <div className="content">
      <Helmet>
        <title>Официальный сайт Сергея Мавроди: Творчество, Новости, KinoTheater</title>
        <meta
          name="description"
          content="Официальный сайт Сергея Мавроди: новости, творчество, видео, книги и архивные материалы."
        />
        <meta name="keywords" content="Сергей Мавроди, МММ, новости, видео, творчество, книги" />
        <meta name="author" content="Сергей Мавроди" />
        <meta property="og:title" content="Главная - Сергей Мавроди" />
        <meta
          property="og:description"
          content="Официальный сайт Сергея Мавроди: новости, видео, творчество и архив."
        />
        <meta property="og:image" content="https://sergey-mavrodi.com/portrait.webp" />
        <meta property="og:url" content="https://sergey-mavrodi.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ru_RU" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Главная - Сергей Мавроди" />
        <meta
          name="twitter:description"
          content="Официальный сайт Сергея Мавроди: новости, видео, творчество."
        />
        <meta name="twitter:image" content="https://sergey-mavrodi.com/portrait.webp" />
        <link rel="canonical" href="https://sergey-mavrodi.com/" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            'name': 'Главная страница',
            'description': 'Официальный сайт Сергея Мавроди: новости, видео, творчество.',
            'url': 'https://sergey-mavrodi.com/',
            'image': 'https://sergey-mavrodi.com/portrait.webp',
            'publisher': {
              '@type': 'Organization',
              'name': 'Сергей Мавроди',
              'logo': {
                '@type': 'ImageObject',
                'url': 'https://sergey-mavrodi.com/images/logo.webp',
              },
            },
            'breadcrumb': {
              '@type': 'BreadcrumbList',
              'itemListElement': [
                {
                  '@type': 'ListItem',
                  'position': 1,
                  'name': 'Главная',
                  'item': 'https://sergey-mavrodi.com/',
                },
              ],
            },
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(
            videos.map((video) => ({
              '@context': 'https://schema.org',
              '@type': 'VideoObject',
              'name': video.name,
              'description': video.description,
              'thumbnailUrl': `https://sergey-mavrodi.com${video.thumbnail}`,
              'uploadDate': video.uploadDate,
              'duration': video.duration,
              'contentUrl': `https://sergey-mavrodi.com/video/${video.src}`,
              'embedUrl': `https://sergey-mavrodi.com/video/${video.src}`,
              'publisher': {
                '@type': 'Organization',
                'name': 'Сергей Мавроди',
                'logo': {
                  '@type': 'ImageObject',
                  'url': 'https://sergey-mavrodi.com/images/logo.webp',
                },
              },
            }))
          )}
        </script>
      </Helmet>
      <h2>ГЛАВНАЯ СТРАНИЦА</h2>
      <MediaBlock src="/images/img7.webp" width={600} height={131} isImage />
      <VideoCarousel videos={carouselVideos} />
      <MediaBlock
      key="mavrodi-warning"
      src="/video/mavrodi-warning.mp4"
      width={590}
      height={340}
      poster="https://sergey-mavrodi.com/video/mavrodi-warning-thumb.webp" // Добавляем poster
      />
      <WarningMessage />
    </div>
  );
};

export default Seite;